/**
 * The Helix of Restoration — the endgame spine of Relikara.
 *
 * Memory fragments recovered in the depths are turned in at the Waystation. Every
 * few memories complete one SECTION of a great DNA-like double helix that stands
 * at the centre of the village, and each completed section forges a Legendary
 * "Memory Relic" weapon you can obtain no other way. Fill all 100 sections and
 * the Helix restores the broken world.
 */
export const HELIX_SECTIONS = 100;

// Memories required to complete each section. Ramps gently so early sections
// come fast and later ones ask for a real collection. (~ hundreds total.)
export function memoriesForSection(section) {
  return 2 + Math.floor((section - 1) / 10);   // 2,2,…(1-10) 3,3…(11-20) … up to 11
}

// Total memories to fully restore the world (handy for UI).
export const HELIX_TOTAL_MEMORIES = (() => {
  let t = 0; for (let s = 1; s <= HELIX_SECTIONS; s++) t += memoriesForSection(s); return t;
})();

// Five ascending strata of 20 sections, each with its own glow colour so the
// monument reads as it climbs.
export const HELIX_TIERS = [
  { name: "Foundation", color: "#4aa3ff" },
  { name: "Ascension",  color: "#5fd35f" },
  { name: "Communion",  color: "#c77dff" },
  { name: "Radiance",   color: "#f0a63c" },
  { name: "Restoration", color: "#ffe8a3" },
];
export function sectionTier(section) {
  return HELIX_TIERS[Math.min(HELIX_TIERS.length - 1, Math.floor((section - 1) / 20))];
}

// Evocative name pool for the Legendary Memory Relics (section → deterministic name).
const RELIC_PREFIX = [
  "Remembered", "Unbroken", "Vaultlight", "Firstborn", "Everdeep", "Hollowed",
  "Ancestral", "Lucent", "Sorrowless", "Waking", "Gilded", "Endless",
  "Forgotten", "Radiant", "Sundered", "Eternal", "Whispered", "Dawnbound",
  "Starbound", "Worldmender",
];
const RELIC_NOUN = [
  "Edge", "Fang", "Vigil", "Requiem", "Oath", "Ember", "Verse", "Warden",
  "Lament", "Crescent", "Reliquary", "Sentinel", "Chorus", "Aegis", "Talon",
];
export function relicName(section) {
  const p = RELIC_PREFIX[(section - 1) % RELIC_PREFIX.length];
  const n = RELIC_NOUN[Math.floor((section - 1) / RELIC_PREFIX.length) % RELIC_NOUN.length];
  return `${p} ${n}`;
}
